// extracted by mini-css-extract-plugin
export var addressHead = "officeInfoWithoutRates-module--addressHead--Hzho5";
export var addressSubtitle = "officeInfoWithoutRates-module--addressSubtitle--6fWYz";
export var head = "officeInfoWithoutRates-module--head--KTjsR";
export var rates = "officeInfoWithoutRates-module--rates--ADDRJ";
export var withoutRates = "officeInfoWithoutRates-module--withoutRates--rBRmW";
export var workSchedule = "officeInfoWithoutRates-module--workSchedule--l-jhr";